(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lflEabInitialized === 'true') return;
    root.dataset.lflEabInitialized = 'true';

    var mainWrap = root.querySelector('[data-gallery-main]');
    var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
    root.querySelectorAll('[data-gallery-src]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        root.querySelectorAll('[data-gallery-src]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainWrap.classList.add('is-loading');
        mainImg.onload = function () { mainWrap.classList.remove('is-loading'); };
        mainImg.src = thumb.getAttribute('data-gallery-src');
        mainImg.alt = thumb.getAttribute('data-gallery-alt') || 'Essential Adjustable Base';
      });
    });

    var variantInput = root.querySelector('[data-variant-input]');
    var price = root.querySelector('[data-current-price]');
    var add = root.querySelector('[data-add-to-cart]');
    root.querySelectorAll('.size[data-variant-id]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        root.querySelectorAll('.size[data-variant-id]').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = button.getAttribute('data-variant-id');
        if (price) price.textContent = button.getAttribute('data-variant-price');
        var available = button.getAttribute('data-variant-available') === 'true';
        if (add) {
          add.disabled = !available;
          add.textContent = available ? 'Add to Cart' : 'Sold Out';
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', button.getAttribute('data-variant-id'));
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    root.querySelectorAll('.q .qhead').forEach(function (head) {
      function toggle() {
        var q = head.closest('.q');
        var body = q ? q.querySelector('p') : null;
        var mark = head.querySelector('span');
        if (!body) return;
        var opening = body.hasAttribute('hidden');
        if (opening) body.removeAttribute('hidden'); else body.setAttribute('hidden', 'hidden');
        head.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (mark) mark.textContent = opening ? '−' : '+';
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    root.querySelectorAll('[data-scroll-to-sizes]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = root.querySelector('#lfl-eab-size-selector');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          var active = root.querySelector('.size.active') || root.querySelector('.size:not([disabled])');
          if (active) active.focus({ preventScroll: true });
        }, 450);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.lfl-eab-pdp').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.lfl-eab-pdp') || (event.target.matches && event.target.matches('.lfl-eab-pdp') ? event.target : null);
    if (root) init(root);
  });
})();
